import React from 'react'
import { BrowserRouter, Switch, Route as RRoute } from 'react-router-dom'
import Route from './components/utils/Route'

// Layout
import DefaultLayout from './layouts/DefaultLayout/DefaultLayout'

// Pages
import Home from './pages/Home'
import Inbox from './pages/Inbox'
import SignIn from './pages/SignIn'
import SignUp from './pages/SignUp'
import Proifle from './pages/User/Profile/Profile'
import LandingPage from './pages/LandingPage/LandingPage'
import Settings from './pages/User/Settings/Settings'

import Feed from './pages/Home/Feed'
import Videos from './pages/Home/Videos'

const Router = () => {

	return (
		<BrowserRouter>
			<Switch>
				<Route
					exact
					path='/'
					component={LandingPage}
					layout={DefaultLayout}
				/>
				<Route
					exact
					path='/login'
					component={SignIn}
					layout={DefaultLayout}
				/>
				<Route
					exact
					path='/signup'
					component={SignUp}
					layout={DefaultLayout}
				/>
				<Route
					path='/home'
					component={Home}
					layout={DefaultLayout}
				>
					<Switch>
						<RRoute exact path='/home' >
							<Feed />
						</RRoute>
						<RRoute exact path='/home/videos'>
							<Videos />
						</RRoute>
					</Switch>
				</Route>
				<Route
					exact
					path='/:username'
					component={Proifle}
					layout={DefaultLayout}
				/>
				<Route
					exact
					path='/user/settings'
					component={Settings}
					layout={DefaultLayout}
				/>
				<Route
					exact
					path='/direct/inbox'
					component={Inbox}
					layout={DefaultLayout}
				/>
			</Switch>
		</BrowserRouter>
	)
}

export default Router